export * from './interfaces/pagination-config.interface';
export * from './interfaces/pages-chunk-changed-event-data.interface';

export * from './classes/pagination';

export * from './pagination.component';
